import React, { Component } from "react";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import PeriodeFilter from "../../common/periodeFilter";
import TabKwitansiBatalFilter from "./tabKwitansiBatalFilter";
import { defaultTableChange } from "../../../../../modules/custom/customTable";
import { getValueFromDDL, removeNullFields } from "../../../../common/mapper";
import dayjs from "dayjs";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import moment from "moment";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import TabBBMDetail from "../tabBBM/tabBBMDetail";
import TabBBKDetail from "../tabBBK/tabBBKDetail";
import {formGroup as formGroupBBM } from "../tabBBM/config";
import {formGroup as formGroupBBK } from "../tabBBK/config";

class TabKwitansiBatal extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
        sort: false,
      },
    },
    {
      name: "tanggalPayment",
      label: "Tanggal BBM/BBK",
      options: {
        sort: false,
      },
    },
    {
      name: "dataPaymentBank",
      label: "Nomor BBM/BBK",
      options: {
        customBodyRender: (value) => <>{value?.paymentBankId}</>,
        sort: false,
      },
    },
    {
      name: "dataDocumentBizpar",
      label: "Jenis Dokumen",
      options: {
        customBodyRender: (value) => <>{value?.value}</>,
        sort: false,
      },
    },
    {
      name: "documentRef1No",
      label: "No. Dokumen Ref 1",
      options: {
        sort: false,
      },
    },
    {
      name: "documentRef1Date",
      label: "Tanggal Dokumen Ref 1",
      options: {
        sort: false,
      },
    },
    {
      name: "dataPaymentBank",
      label: "Nama Bank",
      options: {
        customBodyRender: (value) => <>{value?.dataBank?.bankName}</>,
        sort: false,
      },
    },
    {
      name: "transactionPersonName",
      label: "Terima Dari/Bayar Kepada",
      options: {
        sort: false,
      },
    },
    {
      name: "dataPaymentBank",
      label: "Aksi",
      options: {
          customBodyRender: (val, {rowIndex}) => {
              return (
                  <SimpleButton
                      category="action_button"
                      className="btnAct"
                      onClick={() => this.handleShowDetailKwitansiBatal(val)}
                      icon={
                          <i
                              className="fa fa-lw fa-eye"
                              style={{
                                  backgroundColor: "transparent",
                                  color: "red",
                                  fontSize: 20,
                              }}
                          />
                      }
                  />
              );
          },
      },
    },
  ];

  constructor(props) {
    super(props);
    this.initialSearchData = {
      startBbkBbmDate: dayjs(new Date()).format("DD-MM-YYYY"),
      endBbkBbmDate: dayjs(new Date()).format("DD-MM-YYYY"),
    };
    this.initialPagination = {
      totalData: 1,
      page: 1,
      limit: 5,
    };
    this.state = {
      filterVisible: false,
      filterData: {},
      searchData: this.initialSearchData,
      pagination: this.initialPagination,
      skipNextPaginationFetch: false,
      dataTable: [],
      detailKwitansiBatal: {
        detailId: null,
        detailType: null
      }
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.tabIndex !== this.state.tabIndex) {
      this.refetch({...this.initialSearchData});
    }
    const { submittedFilterData, pagination, skipNextPaginationFetch } =
      this.state;
    if (
      (prevState.pagination.page !== pagination.page ||
        prevState.pagination.limit !== pagination.limit) &&
      !this.state.skipNextPaginationFetch
    ) {
      this.fetchData(submittedFilterData, pagination.page, pagination.limit);
    }
    if (skipNextPaginationFetch) {
      this.setState({ skipNextPaginationFetch: false });
    }

    if (prevProps.kodeCabang?.value !== this.props.kodeCabang?.value) {
      this.handleResetPeriode();
      this.handleResetPagination();
      this.fetchData({
        ...submittedFilterData,
        ...this.initialSearchData,
      });
    }
  }

  fetchData = async (filter = {}, page = 1, limit = 5) => {
    this.setState((prevValue) => ({
      ...prevValue,
      submittedFilterData: filter,
      loading: true,
    }));
    const request = {
      paramFilters: removeNullFields({
        kodeCabang: this.props.kodeCabang?.value || "",
        startBbkBbmDate: filter?.startBbkBbmDate,
        endBbkBbmDate: filter?.endBbkBbmDate,
        ...filter,
      }),
      page,
      limit,
    };

    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getPaymentBankCancel,
      setError: this.props.setError,
      menuName: "Transaksi Bank - Kwitansi Batal",
      args: request,
    });

    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: response.data.data,
        pagination: {
          ...prevValue.pagination,
          totalData: response.data.totalData,
        },
        loading: false,
      }));
    } else {
      this.props.setError({
        menuName: "Transaksi Bank - Kwitansi Batal",
        errorMessage: response.data.message,
      });
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: [],
        pagination: {
          ...prevValue.pagination,
          totalData: 0,
        },
        loading: false,
      }));
    }
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleFilterValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleClearFilter = () => {
    this.setState((prevValue) => ({ ...prevValue, filterData: {} }));
  };

  handleSubmitFilter = async () => {
    const { filterData } = this.state;
    this.handleResetPagination();
    this.handleResetPeriode();

    let request = {
      ...filterData,
      bankId: getValueFromDDL(filterData, "bankId"),
      keyDocumentType: getValueFromDDL(filterData, "keyDocumentType"),
      paymentType: getValueFromDDL(filterData, "paymentType"),
    };
    await this.refetch(request);
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: false,
      searchData: {
        startBbkBbmDate: null,
        endBbkBbmDate: null,
      },
    }));
  };

  handlePeriodChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: {
        ...prevValue.searchData,
        [name]: moment(value).format("DD-MM-YYYY"),
      },
    }));
  };

  handleSubmitPeriod = async () => {
    this.setState({ skipNextPaginationFetch: true });
    this.handleResetPagination();
    const paymentDate = removeNullFields(this.state?.searchData);
    this.refetch({ ...paymentDate });
  };

  getPeriodInput = (data) => ({
    startBbkBbmDate: data?.startBbkBbmDate
      ? dayjs(data.startBbkBbmDate).format("DD-MM-YYYY")
      : null,
    endBbkBbmDate: data?.endBbkBbmDate
      ? dayjs(data.endBbkBbmDate).format("DD-MM-YYYY")
      : null,
  });

  refetch = async (filter = {}) => {
    this.setState((prevValue) => ({ ...prevValue, loading: true }));
    await this.fetchData({ ...filter });
    this.setState((prevValue) => ({ ...prevValue, loading: false }));
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleResetPeriode = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: this.initialSearchData,
    }));
  };

  handleResetPagination = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: this.initialPagination,
      skipNextPaginationFetch: true,
    }));
  };

  handleRefresh = () => {
    this.handleResetPagination();
    this.handleResetPeriode();
    this.refetch({ tanggalBBM: this.initialSearchData });
  };

  handleShowDetailKwitansiBatal = (dataPaymentBank) => {
    const detailId = dataPaymentBank?.paymentId || null;
    let detailType = null;

    if (dataPaymentBank) {
      detailType = dataPaymentBank.paymentBankId?.startsWith("BBM") ? "BBM" : "BBK";
    }

    this.setState((prev) => ({
      ...prev,
      detailKwitansiBatal: { detailId, detailType },
    }));
  }

  renderDetail = () => {
    const { detailId, detailType } = this.state.detailKwitansiBatal;
    if (!detailId) return null;
    
    const commonProps = {
      id: detailId,
      visible: true,
      isEditable: false,
      onClickClose: () => this.handleShowDetailKwitansiBatal(),
      isPreview: true
    };
  
    if (detailType === 'BBM') {
      return (
        <TabBBMDetail
          {...this.props}
          {...commonProps}
          formGroup={formGroupBBM}
          title="Detail BBM KWITANSI BATAL"
          kodeCabang={this.props.kodeCabang?.value}
        />
      );
    }
  
    if (detailType === 'BBK') {
      return (
        <TabBBKDetail
          {...commonProps}
          formGroup={formGroupBBK}
          title="Detail BBK KWITANSI BATAL"
          namaCabang={this.props.kodeCabang}
          kodeCabang={this.props.kodeCabang?.value}
        />
      );
    }
  
    return null;
  };


  render() {
    return (
      <div>
        <PeriodeFilter
          state={this.state}
          withFilterButton
          startDateName="startBbkBbmDate"
          endDateName="endBbkBbmDate"
          onValueChange={this.handlePeriodChange}
          onSubmit={this.handleSubmitPeriod}
          onShowFilter={this.handleFilterVisibility}
        />
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.tableColumns}
          rowsPerPage={this.state.pagination.limit}
          page={this.state.pagination.page - 1}
          toCount={this.state.pagination.totalData}
          options={defaultTableChange(
            this.handleChangePage,
            this.handleRowsPerPage
          )}
        />
        {this.state.filterVisible && (
          <TabKwitansiBatalFilter
            tab="Kwitansi Batal"
            kodeCabang={this.props.kodeCabang?.value}
            data={this.state.filterData}
            visible={this.state.filterVisible}
            onClickClose={this.handleFilterVisibility}
            onValueChange={this.handleFilterValueChange}
            onSubmit={this.handleSubmitFilter}
            onClear={this.handleClearFilter}
          />
        )}
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
        {this.renderDetail()}
      </div>
    );
  }
}

export default TabKwitansiBatal;
